<template>
    <div class="dvBgiBox">
        <div style="height: 70px;">
            <p style="font-size: 22px;font-weight: 600;color: #fff;">{{ $t('overview.title') }}</p>
        </div>

        <div style="display: flex;justify-content: center;align-items: center;height: 110px;">
            <div class="left">
                <span>{{ $t('overview.online') }}</span>
                <span style="font-size: 20px;font-weight: 600;color: #fff;">{{ device_number_list[1].value }}</span>
            </div>

            <div class="zhongx">

                <!-- <dv-active-ring-chart :config="config" style="width: 60px;height: 60px" /> -->
                <div class='circle'>
                    <span style="color: #31c8fc;font-size: 15px;">{{ bfb() }}%</span>
                </div>
            </div>

            <div class="left right" style="background-position: right center;">
                <span style="font-size: 20px;font-weight: 600;color: #fff;">{{ device_number_list[2].value }}</span>
                <span>{{ $t('overview.offline') }}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            config: {
                data: [{
                    value: 55,
                    color: '#062740',
                }, {
                    value: 55,
                    color: '#31c8fc',
                },],
                lineWidth: 5,
                digitalFlopStyle: {
                    fontSize: 14,
                    fill: '#31c8fc',
                    textAlign: 'center'
                },
            }
        };
    },
    props: {
        device_number_list:{}
    },
    watch: {

    },

    methods: {
        bfb() {
            return ((this.device_number_list[1].value / this.device_number_list[0].value) * 100).toFixed(2)
        },

    }

}
</script>

<style scoped>
.dvBgiBox {
    width: 100%;
    background-image: url("../../assets/dvBgiBoxleft.png");
    background-size: 100% 100%;
    padding: 5px 10px 10px 10px;
    margin-bottom: 20px;
}

.left {
    width: 38%;
    height: 40px;
    background-image: url("../../assets/left01.png");
    background-size: 291% 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
}

.zhongx {
    width: 120px;
    height: 120px;
    margin: 0px 8px;
    background-image: url("../../assets/zhongx.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle {
    width: 70px;
    height: 70px;
    border: #31c8fc solid 5px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>